import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  mainDiv: {
    width: "100%"
  },
  countSpan: {
    marginTop: "16px",
    fontSize: "16px",
    lineHeight: "24px",
    fontFamily: "Manrope"
  }
}));

export default styles;
